import { observer } from 'mobx-react-lite';

import { Table } from '@/components/table';
import { useMassUpdateCashedRelStores } from '@/utils/store';

import { lotPledgeStore } from '@/stores';
import { getColumns } from './setup';

const store = lotPledgeStore;

export const Pledges = observer(({ lotId, lot }: any) => {
  const items = store.items;

  useMassUpdateCashedRelStores([store], lotId);
  const columns = getColumns(lotId);

  return (
    <Table
      rowKey="id"
      columns={columns}
      dataSource={[...items]}
      store={store}
      loading={store.loading}
      scroll={{ x: 950 }}
      relId={lotId}
    />
  );
});
